import { styled, css } from 'styled-components';
import { breakpoints, Size } from '../../../abstracts';
import { dontForwardProps, pxToRem } from '../../../util';
import { BaseTemplateStyles, BasePageTitleContainer, BaseMainPanelContainer, BaseImageContainerStyles } from '../elements';
export const DynamicAssetBaseTemplate = styled.div.withConfig(dontForwardProps()).withConfig({
  componentId: "aui__sc-qkb8lo-0"
})(["", ";grid-template-rows:auto 1fr;", " ", " ", "{padding-left:var(--aui-spacing-300);padding-right:var(--aui-spacing-300);", "}", "{height:calc(100vh - ", ");", " grid-template-columns:7fr 5fr;grid-template-rows:1fr;padding-left:var(--aui-spacing-600);padding-right:var(--aui-spacing-600);}", "{margin-left:auto;margin-right:auto;}"], BaseTemplateStyles, props => props.hasButtonGroup ? props.progressStepper ? `
    grid-template-areas:
      'image'
      'progress-stepper'
      'main-content'
      'button-group';
      grid-template-rows: min-content max-content auto min-content;
      ` : `
    grid-template-areas:
      'image'
      'main-content'
      'button-group';` : `
    grid-template-areas:
      'image'
      'main-content';
    `, props => !props.hasButtonGroup && `
    @media (max-width: ${Size.MD2 - 1}px) {
      padding-bottom: var(--aui-spacing-600);
    }
  `, breakpoints.md, props => props.hasButtonGroup && props.progressStepper && `
        grid-template-areas: 
          'image'
          'main-content'
          'button-group';
          grid-template-rows: auto 1fr;
      `, breakpoints.md2, props => props.upperVerticalOffset || 0, props => props.hasButtonGroup ? `
      grid-template-areas:
        'main-content image'
        'button-group image';
    ` : `grid-template-areas: 'main-content image';
      `, breakpoints.xl);
export const PageTitleContainer = styled(BasePageTitleContainer).withConfig({
  componentId: "aui__sc-qkb8lo-1"
})(["", "{margin-right:var(--aui-spacing-300);margin-top:var(--aui-spacing-600);}", "{margin-right:0;}"], breakpoints.md2, breakpoints.xl);
export const MainPanelContainer = styled(BaseMainPanelContainer).withConfig({
  componentId: "aui__sc-qkb8lo-2"
})(["", "{margin-right:var(--aui-spacing-300);}", "{margin-right:0;}"], breakpoints.md2, breakpoints.xl);
const getMobileImageBackground = ({
  assetType
}) => {
  if (assetType === 'doodle') {
    return css(["background-image:linear-gradient( 180deg,var(--aui-surface-variant) ", "rem,transparent ", "rem );height:", "rem;"], pxToRem(112), pxToRem(80), pxToRem(192));
  } else if (assetType === 'image') {
    return css(["background-image:linear-gradient( 180deg,var(--aui-surface-variant) ", "rem,transparent ", "rem );height:", "rem;"], pxToRem(144), pxToRem(80), pxToRem(256));
  } else if (assetType === 'flat') {
    return css(["background-color:var(--aui-surface-variant);"]);
  }
};
const getDesktopImageBackground = ({
  assetType
}) => {
  if (assetType === 'doodle') {
    return css(["background-image:linear-gradient( 180deg,var(--aui-surface-variant) ", "rem,transparent ", "rem );height:", "rem;"], pxToRem(154), pxToRem(106), pxToRem(260));
  } else if (assetType === 'image') {
    return css(["background-image:linear-gradient( 180deg,var(--aui-surface-variant) ", "rem,transparent ", "rem );height:", "rem;"], pxToRem(168), pxToRem(106), pxToRem(304));
  }
};
export const ImageContainer = styled.div.withConfig(dontForwardProps()).withConfig({
  componentId: "aui__sc-qkb8lo-3"
})(["", ";display:grid;align-items:end;justify-content:center;", " ", " ", "{", "}", "{align-items:center;justify-content:center;box-sizing:border-box;margin-left:0;padding-left:var(--aui-spacing-600);padding-right:var(--aui-spacing-600);background-color:var(--aui-surface-variant);width:calc(100% + var(--aui-spacing-600));height:100%;}", "{width:calc(100% - var(--aui-spacing-300));margin-left:var(--aui-spacing-300);}"], BaseImageContainerStyles, getMobileImageBackground, props => props.hideOnMobile && css(["@media (max-width:", "px){display:none;}"], Size.MD - 1), breakpoints.md, getDesktopImageBackground, breakpoints.md2, breakpoints.xl);
export const ImageBackground = styled.div.withConfig({
  componentId: "aui__sc-qkb8lo-4"
})(["background-color:var(--aui-elevated-level-01);border-radius:50%;box-shadow:0 0 0.25rem 0 var(--aui-fills-drop-shadow),0 0 0.25rem 0.125rem var(--aui-fills-drop-shadow);"]);
export const doodleCSS = css(["width:", "rem;height:", "rem;padding:var(--aui-spacing-300);", "{width:", "rem;height:", "rem;padding:var(--aui-spacing-400);}", "{width:", "rem;height:", "rem;padding:var(--aui-spacing-500);}"], pxToRem(160), pxToRem(160), breakpoints.md, pxToRem(228), pxToRem(228), breakpoints.md2, pxToRem(260), pxToRem(260));
export const imageCSS = css(["width:", "rem;height:", "rem;padding:var(--aui-spacing-400);", "{width:", "rem;height:", "rem;padding:var(--aui-spacing-400);}", "{width:", "rem;height:", "rem;padding:var(--aui-spacing-400);}"], pxToRem(224), pxToRem(224), breakpoints.md, pxToRem(272), pxToRem(272), breakpoints.md2, pxToRem(348), pxToRem(348));
export const flatImageCSS = css(["object-fit:contain;height:", "rem;padding-bottom:var(--aui-spacing-200);padding-top:var(--aui-spacing-200);", "{height:", "rem;}", "{height:", "rem;}"], pxToRem(224), breakpoints.md, pxToRem(272), breakpoints.md2, pxToRem(348));
export const Image = styled.img.withConfig(dontForwardProps()).withConfig({
  componentId: "aui__sc-qkb8lo-5"
})(["box-sizing:border-box;", " ", " ", ""], props => props.assetType === 'doodle' && doodleCSS, props => props.assetType === 'image' && imageCSS, props => props.assetType === 'flat' && flatImageCSS);